export const NEW_CUSTOMER_COUPON_EPPO_ID = 'web-2425-new-customer-coupon';
export const NEW_CUSTOMER_COUPON_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const BOOKING_ENQUIRY_REBUILD_EPPO_ID = 'web-2479-booking-enquiry-rebuild';
export const BOOKING_ENQUIRY_REBUILD_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const SHOW_LOGIN_MODAL_ON_UBR_PAGE_LOAD_EPPO_ID = 'web-2604-ubr-show-login-on-page-load';
export const SHOW_LOGIN_MODAL_ON_UBR_PAGE_LOAD_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const WEB_2344_NATIVE_SEARCH_CRITERIA = 'WEB-2344-Native-Search-Criteria';
export const WEB_2344_NATIVE_SEARCH_CRITERIA_VALUES = {
  ON: 'v2',
  OFF: 'off',
};

export const CREATE_MOBILE_APP_BANNER_EPPO_ID = 'web-2715-create-mobile-app-banner';
export const CREATE_MOBILE_APP_BANNER_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const SET_WEEKLY_AS_THE_DEFAULT_OPTION_FOR_RWB_EPPO_ID =
  'web-2721-set-weekly-as-the-default-option-for-rwb';
export const SET_WEEKLY_AS_THE_DEFAULT_OPTION_FOR_RWB_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};
